import React, { Component } from 'react'
import { connect } from 'react-redux'
import { handleSearch } from '../../redux/actions/shopActions'
import { Input } from 'antd'

export class SearchBar extends Component {
  handleSearch=(e)=>{
    this.props.handleSearch(e.target.value)
  }
  render() {
    return (
      <div className="search-bar">
        <Input 
          prefix={<i className="fas fa-search"></i>}
          placeholder="Zoeken naar producten"
          onChange={this.handleSearch}
          allowClear 
        />     
      </div>
    )
  }
}

export default connect(null, { handleSearch })(SearchBar)
